
import { Mic, Square } from 'lucide-react';
import { BrandingSettings } from '@/hooks/useReferentBranding';

interface RecordingStateProps {
  isRecording: boolean;
  recordingTime: number;
  maxRecordingTime: number;
  onStartRecording: () => void;
  onStopRecording: () => void;
  branding?: BrandingSettings | null;
}

const formatTime = (seconds: number) => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};

export const RecordingState = ({
  isRecording,
  recordingTime,
  maxRecordingTime,
  onStartRecording,
  onStopRecording,
  branding
}: RecordingStateProps) => {
  const primaryColor = (branding?.enabled && branding?.primaryColor) ? branding.primaryColor : '#4ECDC4';
  
  return (
    <div className="flex flex-col items-center space-y-8 font-['Bricolage_Grotesque']">
      {/* Timer central - grand format */}
      <div className="text-6xl font-mono text-gray-800 font-light tracking-wider">
        {formatTime(recordingTime)}
      </div>
      
      {/* Bouton circulaire avec icône microphone */}
      <button
        onClick={isRecording ? onStopRecording : onStartRecording}
        className="w-20 h-20 rounded-full flex items-center justify-center transition-all duration-200 hover:scale-105 shadow-lg"
        style={{ 
          backgroundColor: isRecording ? '#ef4444' : primaryColor 
        }}
      >
        {isRecording ? (
          <Square className="h-8 w-8 text-white" fill="white" />
        ) : (
          <Mic className="h-8 w-8 text-white" />
        )}
      </button>
      
      {/* Instructions contextuelles */}
      <div className="text-center space-y-2">
        {isRecording ? (
          <>
            <p className="text-lg font-medium text-gray-700">
              Enregistrement en cours...
            </p>
            <p className="text-sm text-gray-500">
              Parlez clairement près de votre microphone
            </p>
          </>
        ) : (
          <>
            <p className="text-lg font-medium text-gray-700">
              Cliquez pour démarrer l'enregistrement
            </p>
            <p className="text-sm text-gray-500">
              Durée recommandée : 1 à 3 minutes
            </p>
          </>
        )}
      </div>
    </div>
  );
};
